import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { useTranslation } from "react-i18next";
import { Dashboard } from "../../components/Charts.jsx/Dashboard";

const DashboardGeneral = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("charts.title_dashboard"),
					component: <Dashboard />,
				}}
				right={null}
			/>
		</>
	);
};

export { DashboardGeneral };
